import apiService from "./api";

// Zahtjevi dobavljaca za nalog (sa javnog linka narudzbenice). Obradjuju ih restoran koji je poslao link i admin.
const supplierAccountRequestService = {
  list(status = "pending") {
    return apiService.get("/supplier-account-requests", { status });
  },
  approve(id) {
    return apiService.post(`/supplier-account-requests/${id}/approve`);
  },
  reject(id) {
    return apiService.post(`/supplier-account-requests/${id}/reject`);
  },
};

export default supplierAccountRequestService;
